import React from 'react'

export const PatientAccessMessage = () => (
  <>
    El paciente recibirá en su correo electrónico una nueva contraseña temporal para monitorear el estado de su estudio.<br />
    Si se generan múltiples envíos, el acceso válido será siempre el del correo más reciente.
  </>
)
